module.exports = __webpack_public_path__ + "static/img/nguyenduchoan.1669ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nguyenduchoan.png
// module id = 1fEe
// module chunks = 1